<mat-form-field appearance="fill" color="primary" class="w-100">
  <mat-label *ngIf="control?.hasLabel" [style.color]="control.labelColour">{{control.label}}</mat-label>
  <app-mat-date-time-input [enableTime]="false" #dateTimeInputComponent placeholder="{{control?.placeHolder}}" [(ngModel)]="value" (ngModelChange)="onValueChanges($event)"></app-mat-date-time-input>
  <button mat-icon-button matSuffix (click)="dateTimeInputComponent.togglePicker()"><mat-icon>today</mat-icon></button>
</mat-form-field>
